export const EMOTION_TYPES = ["Calm", "Excited", "Happy", "Confident", "Neutral", "Gulity", "Frustrated", "Angry", "Anxious", "Sad", "Overwhelmed"] as const;
export type EmotionType = typeof EMOTION_TYPES[number]; 